import { useContext, useEffect } from "react";
import { InstitutionContext } from "../contexts/InstitutionContext";
import InstitutionStore from "../store/institution.store";

export const iswEnabled = (institution: any) => {
  return institution?.settings?.providers?.zimba_wallet_isw;
};

const useInstitution = () => {
  const { business, setBusiness }: any = useContext(InstitutionContext);
  const subscription = InstitutionStore.subscribe(setBusiness);

  useEffect(() => {
    return () => {
      subscription.unsubscribe();
    };
  }, []);

  return business;
};

export default useInstitution;
